const sendResp = (data, resp) => {
  return {
    _req: { _id: data._id },
    resp: { ...resp }
  };
};

export const ShowMesage = async (data) => {
  const { Toast } = await import("widgets/feedback");
  return new Promise((resolve, reject) => {
    Toast.showInfo({
      message:
        typeof data.message === "object"
          ? JSON.stringify(data.message)
          : data.message
    });
  });
};

export const ShowAlert = async (data) => {
  const { Alert } = await import("widgets/feedback");
  return new Promise((resolve, reject) => {
    Alert.showAlert({
      ...data.data,
      onOK: () => {
        resolve({
          ...sendResp(data, { action: "OK" })
        });
      }
    });
  });
};

export const ShowConfirm = async (data) => {
  const { Alert } = await import("widgets/feedback");
  return new Promise((resolve, reject) => {
    Alert.showConfirm({
      ...data.data,
      onOK: () => {
        resolve({
          ...sendResp(data, { action: "OK" })
        });
      },
      onCancel: () => {
        resolve({
          ...sendResp(data, { action: "CANCEL" })
        });
      }
    });
  });
};

export const openPage = (data) => {
  window.dispatchEvent(
    new CustomEvent("kfSDKOpenPage", { detail: { ...data } })
  );
};
